import { Link } from "react-router-dom";
import { Car, Home, Heart, Briefcase, Shield, Users, ArrowRight } from "lucide-react";

const services = [
  {
    icon: Car,
    title: "Auto Insurance",
    desc: "Compare rates from 30+ carriers. Liability, collision, comprehensive — find the right Arizona auto coverage.",
    href: "/services/auto-insurance",
  },
  {
    icon: Home,
    title: "Homeowners Insurance",
    desc: "Protect your Arizona home from monsoons, fire, and theft with comprehensive property coverage.",
    href: "/services/homeowners-insurance",
  },
  {
    icon: Briefcase,
    title: "Commercial Insurance",
    desc: "General liability, BOP, workers' comp — tailored coverage for Arizona small businesses.",
    href: "/services/commercial-insurance",
  },
  {
    icon: Shield,
    title: "Health Insurance",
    desc: "Individual, family, and ACA marketplace plans. Navigate Arizona's health coverage options.",
    href: "/services/health-insurance",
  },
  {
    icon: Heart,
    title: "Life Insurance",
    desc: "Term, whole, and universal life insurance to protect your family's financial future.",
    href: "/services/life-insurance",
  },
  {
    icon: Users,
    title: "Group Benefits",
    desc: "Health, dental, vision, and life insurance packages for Arizona employers of all sizes.",
    href: "/services/group-benefits",
  },
];

const ServicesGrid = () => {
  return (
    <section id="services" className="py-16 md:py-24">
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-semibold mb-3">Insurance Solutions for Arizona</h2>
          <p className="text-muted-foreground max-w-prose-wide mx-auto leading-relaxed">
            As independent brokers, we shop the market so you don't have to. Compare plans from 30+ top-rated carriers.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((s) => {
            const Icon = s.icon;
            return (
              <Link
                key={s.title}
                to={s.href}
                className="group bg-surface rounded-2xl p-6 shadow-card hover:shadow-elevated transition-shadow duration-300"
              >
                <div className="w-11 h-11 rounded-xl bg-primary flex items-center justify-center mb-4">
                  <Icon className="w-5 h-5 text-primary-foreground" />
                </div>
                <h3 className="text-lg font-semibold mb-2 group-hover:text-primary transition-colors">{s.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed mb-4">{s.desc}</p>
                <span className="inline-flex items-center text-sm font-medium text-primary group-hover:gap-2 gap-1 transition-all">
                  Learn More <ArrowRight className="w-4 h-4" />
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesGrid;
